import { render } from "./settings-tabs.vue?vue&type=template&id=169ea7a6&scoped=true"
import script from "./settings-tabs.vue?vue&type=script&lang=js"
export * from "./settings-tabs.vue?vue&type=script&lang=js"

import "./settings-tabs.vue?vue&type=style&index=0&id=169ea7a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169ea7a6"]])

export default __exports__